/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1200px){.my-container[_ngcontent-%COMP%]{position:absolute;left:50%;-webkit-transform:translate(-50%,0);transform:translate(-50%,0);top:-100px;bottom:auto;width:425px;height:auto;border-radius:4px}.my-container[_ngcontent-%COMP%]   .balloon[_ngcontent-%COMP%]{padding-top:15px}.my-container[_ngcontent-%COMP%]   .balloon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:75px;height:95px}}"];
export { styles as styles };
